/**
 * 开发车道（harness/dev/lane）：在共享 dev 集群上，带 `X-Yep-Lane: <名字>` 的请求走开发者
 * 自己的服务副本，不带的走共享基线。
 *
 * 浏览器控制台 `localStorage.yepLane = 'alice'` 即可把整个前端会话切进车道，不用重启。
 * HTTP 走请求头；WebSocket 握手带不上自定义头，所以走 `?lane=` 查询参数，
 * 网关的 pre-function 会在路由前把它转成同一个头。
 *
 * 这里只读一个 key，生产环境没有人设它，为空时不加任何东西。
 */
export const LANE_STORAGE_KEY = 'yepLane';
export const LANE_HEADER = 'X-Yep-Lane';

const LANE_RE = /^[a-z0-9-]{1,20}$/;

export function getDevLane(): string | null {
  try {
    const v = typeof localStorage !== 'undefined' ? localStorage.getItem(LANE_STORAGE_KEY) : null;
    return v && LANE_RE.test(v) ? v : null;
  } catch {
    return null;
  }
}
